import Box from '@mui/material/Box';
import {ComponentPropsAdapter} from '../../types';
import CollectorCardContainer, {
  ICollectorCardContainer,
} from '@wearesection/bandai-react-components/organisms/CollectorCardContainer';
import Container from '@wearesection/bandai-react-components/atoms/Container';
import {PLACEHOLDER_IMG} from '~/constants';
import {CollectionsForGame} from '~/graphql/types';
import {documentToReactComponents} from '@contentful/rich-text-react-renderer';
import {getOptions} from '../body-article/body-rich-text-renderer-options';
import RenderNextImage from '../../atoms/render-next-image';
import {getOptionsLabel} from './getOptionLabel';
import {convertToSlug, GetRouter} from '~/utils';
import {handleReturnLocaleStore} from '../home-page-mash-thead/home-page-mash-thead';

type CollectorCardContainerExt = CollectionsForGame &
  ICollectorCardContainer & {
    dataCollectorCard: CollectionsForGame[];
    slugGame: string;
    fromText: string;
  };

const adapter: ComponentPropsAdapter<CollectorCardContainerExt, ICollectorCardContainer> = (
  data: any
) => {
  const bcProductReference = data?.bcProductReference;
  // const BCNameGame = bcProductReference?.title || '';
  // const isMerchandise = bcProductReference?.isMerchandise || false;
  const isPreOrder = bcProductReference?.isPreOrder || false;
  // const linkStore = `${process.env.NEXT_PUBLIC_STORE_SITE_URL}${handleReturnLocaleStore(
  //   data?.locale || ''
  // )}/store/games/${convertToSlug(BCNameGame)}`;
  const isComingSoon = data?.isComingSoon;
  let ctaLink = '';
  let labelCtaLink = '';

  return {
    title: data?.title || 'For collectors',
    dataCollectorCard: data?.dataCollectorCard?.map((card: any) => {
      const label = {
        ...card?.description?.json,
        content: [card?.description?.json?.content?.[0]],
      };

      const bulletPointProps = {
        ...card?.description?.json,
        content: card?.description?.json?.content?.filter((item: any, index: number) => {
          if (index !== 0) {
            return item;
          }
        }),
      };

      ctaLink = card?.ctaLink || '';
      labelCtaLink = card?.labelCtaLink || '';
      const isProductPage = !!ctaLink.includes(`${process.env.NEXT_PUBLIC_STORE_SITE_URL}`);

      const valueButtonProps = () => {
        const result = {};
        if (ctaLink) {
          if (isProductPage) {
            if (labelCtaLink) {
              return {
                variant: 'secondary',
                label: labelCtaLink || '',
                externalLink: ctaLink || '',
                target: '_blank',
              };
            }
            return {
              variant: 'secondary',
              label: isPreOrder
                ? data?.dataTranslation['estore-home-page-title-button']
                : data?.dataTranslation['product-buy'] || '',
              externalLink: ctaLink || '',
              target: '_blank',
            };
          }
          if (!isProductPage) {
            if (labelCtaLink) {
              return {
                variant: 'secondary',
                label: labelCtaLink || '',
                externalLink: ctaLink || '',
                target: '_blank',
              };
            }
            return result;
          }
        }
        if (labelCtaLink) {
          return {
            variant: 'secondary',
            label: labelCtaLink || '',
            externalLink: '',
            disabled: true,
          };
        }
        if (isComingSoon) {
          return {
            variant: 'secondary',
            label: data?.dataTranslation['coming-soon'] || '',
            externalLink: '',
            disabled: true,
          };
        }
        return result;
      };

      return {
        title: card.title ?? '',
        mainImage: '',
        mainImageNext: (
          <RenderNextImage
            src={card?.featuredCollectionImage?.media?.url ?? PLACEHOLDER_IMG}
            width={card?.featuredCollectionImage?.media?.width}
            height={card?.featuredCollectionImage?.media?.height}
            alt={card?.featuredCollectionImage?.alt || ''}
          />
        ),
        expandableBulletPointsProps: {
          color: '#121212',
          label: label.content[0]
            ? (documentToReactComponents(label, getOptionsLabel(label)) as any)
            : '',

          bulletPointProps:
            (bulletPointProps.content &&
              (documentToReactComponents(
                bulletPointProps,
                getOptions(card?.description)
              ) as any)) ??
            '',
        },
        buttonProps: valueButtonProps(),
        // !labelCtaLink && !ctaLink && !BCNameGame
        //   ? {}
        //   : {
        //       variant: 'secondary',
        //       label:
        //         labelCtaLink ||
        //         (isPreOrder
        //           ? data?.dataTranslation['estore-home-page-title-button']
        //           : data?.dataTranslation['product-buy']) ||
        //         '',
        //       externalLink: ctaLink || linkStore || '',
        //       target: ctaLink ? '_blank' : 'present',
        //     },
        // Web launch commentx
        // priceProps: {
        //   label: data?.fromText ?? '',
        //   currency: 'S$',
        //   amount: 84,
        // },
        priceProps: {
          label: '',
          currency: '',
          amount: '',
          noFormat: 1,
        },
      };
    }),
    // isComingSoon: !ctaLink ? {label: labelCtaLink || ''} : undefined,
  };
};
const PADDING_COMPONENT: any = {
  '/games/[slug]': {
    paddingTop: {
      xs: '72px',
      lg: '40px',
    },
    paddingBottom: {
      xs: '72px',
      lg: '40px',
    },
  },
};
const GameDetailCharacterOrganisms: React.FC<CollectorCardContainerExt & any> = props => {
  const {pathname} = GetRouter();
  const ComponentProps = adapter(props);

  return (
    <Box sx={PADDING_COMPONENT[pathname] ?? {}}>
      <Container
        sx={{
          a: {
            width: 'fit-content !important',
            minWidth: '120px',
          },
        }}
      >
        <CollectorCardContainer {...ComponentProps} id={props?.id || ''} />
      </Container>
    </Box>
  );
};

export default GameDetailCharacterOrganisms;
